export default "__VITE_ASSET__CIa$_NDU__"